export enum D3MapUnit {
    kilometer = 1,
    mile = 2
}
